import { useQuery } from '@apollo/client/react';
import { CompanyFeaturesDocument } from './CompanyFeatures.gql';
export const useCompanyFeatures = () => {
    const { data, error, loading } = useQuery(CompanyFeaturesDocument);
    const isFeatureAvailable = (feature) => (data === null || data === void 0 ? void 0 : data.companyFeatures.some((f) => f.featureId === feature)) || false;
    return { error, loading, isFeatureAvailable };
};
